import { Box, Icon, Typography } from "@mui/material";
import { useEffect } from "react";
import { customColors, theme } from "theme";

type Props = {
  id: string;
  iconClassName?: string;
  label: string;
  customIcon?: JSX.Element;
  small?: boolean;
  maxHeight?: string;
};

export const headerOuBannerDependendoDaInterpretacaoH1defaultFontSize = {
  large: "45px",
  normal: "24px",
  small: "20px",
};

const HeaderOuBannerDependendoDaInterpretacaoH1 = ({
  id,
  iconClassName,
  label,
  customIcon,
  small,
  maxHeight,
}: Props) => {
  useEffect(() => {
    if (!iconClassName && !customIcon) throw new Error("Ícone obrigatório");
    // eslint-disable-next-line
  }, []);

  const fontSize = small
    ? headerOuBannerDependendoDaInterpretacaoH1defaultFontSize.small
    : headerOuBannerDependendoDaInterpretacaoH1defaultFontSize.normal;
  return (
    <Box
      id={`${id}-header-banner-container`}
      sx={{
        width: "100%",
        borderTop: `1px solid ${customColors.cinzaClaro}`,
        borderBottom: `1px solid ${customColors.cinzaClaro}`,
        padding: "5px 0",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginBottom: small ? "5px" : "10px",
        maxHeight: maxHeight,
      }}
    >
      {customIcon ? (
        customIcon
      ) : (
        <Icon
          id={`${id}-header-banner-icon`}
          className={iconClassName}
          sx={{ color: theme.palette.text.primary, fontSize, width: "50px" }}
        />
      )}
      <Typography
        id={`${id}-header-banner-label`}
        sx={{
          paddingLeft: "25px",
          fontSize,
          fontWeight: "600",
          color: theme.palette.text.primary,
          userSelect: "none",
        }}
      >
        {label}
      </Typography>
    </Box>
  );
};

export default HeaderOuBannerDependendoDaInterpretacaoH1;
